<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-card-text>
        <b>
          اينجانب {{ fullName }} بدينوسيله درخواست خود را جهت بازبيني نمره درس
          {{ course ? course.N_Title : "" }} اعلام ميدارم.
        </b>
      </v-card-text>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          <b>نام درس:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="8"
          >{{ course ? course.N_Title : "" }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          <b>نمره فعلي:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          {{ course ? course.Mark : "" }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          <b>تاريخ ثبت اعتراض:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="8"> {{ TODAY }} </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12">
          <b>توضیحات(اختیاری):</b>
        </v-col>
        <v-col class="d-flex" cols="12">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-card-actions style="direction: ltr">
        <v-btn
          class="register"
          color="primary white--text"
          rounded
          @click="$emit('addEteraz', null)"
        >
          بستن
        </v-btn>
        <v-btn
          class="register"
          color="red white--text"
          rounded
          @click="
            $emit('addEteraz', course.LesRegSerial, course.HashToken, comment)
          "
        >
          ثبت
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { TODAY } from "@/utils/constants";
export default {
  data() {
    return { comment: "", TODAY: TODAY };
  },
  props: ["show", "course"],

  computed: {
    fullName() {
      return this.$store.getters.FullName;
    },
  },
  watch: {
    show() {
      this.comment = "";
    },
  },
};
</script>
<style scoped>

.v-card {
  margin: 0;
  padding: 30px 10px 10px;
  border-radius: 4px !important;
}
.register {
  width: 30% !important;
  max-width: 150px !important;
}
</style>
